import React, {useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import {images} from "../../assets";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {useLanguage} from "../../contexts/LanguageContext";
import QRCodeSection from "../qrCodeSection";

const NoCamera = () => {
  const {sessionId} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const {t} = useLanguage();
  const [redirectUrl] = useState(location.state?.redirectUrl);

  const handleCancel = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{
      bgcolor: '#f5f5f7',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pb: '197px',
      pt: '20px',
      minHeight: '100vh'
    }}>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', width: '100%'}}>
        <Box display="flex" justifyContent="center" sx={{pt: 1, mb: 10}}>
          <img
            src={images.certageLogo}
            alt="Logo"
            style={{
              width: "min(70vw, 300px)",
              height: "auto",
              maxHeight: "140px",
            }}
          />
        </Box>

        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '38px',
            alignItems: 'center',
            maxWidth: '729px',
            width: '100%',
            px: 2
          }}>

            {/* Error Box */}
            <Box sx={{
              bgcolor: '#fff3f3',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              alignItems: 'center',
              py: '23px',
              px: 2,
              position: 'relative',
              borderRadius: '4px',
              width: '100%',
              border: '1px solid #f9f9f9',
              boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.1)'
            }}>
              <Box sx={{width: '52px', height: '52px'}}>
                <img
                  src={images.cameraBlockedError}
                  alt="Error"
                  style={{width: '100%', height: '100%'}}
                />
              </Box>

              <Typography sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                lineHeight: 1.375,
                color: '#403e3e',
                fontSize: '20px',
                textAlign: 'center',
                width: '100%'
              }}>
                {t.cameraBlocked.title}
              </Typography>
              <Typography sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                lineHeight: 1.375,
                color: '#403e3e',
                fontSize: '20px',
                textAlign: 'center',
                width: '100%'
              }}>
                {t.cameraBlocked.description}
              </Typography>
            </Box>

            <Typography sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              lineHeight: 1.375,
              color: '#403e3e',
              fontSize: '20px',
              textAlign: 'center',
              width: '100%'
            }}>
              <span>{t.cameraBlocked.instruction}</span>
              <br/>
              <Box component="span" sx={{fontWeight: 700}}>
                {t.cameraBlocked.qrHighlight}
              </Box>
            </Typography>

            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2}}>
              <QRCodeSection
                sessionId={sessionId}
                redirectUrl={redirectUrl}
              />
            </Box>

            <Typography sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              lineHeight: 1.375,
              fontSize: '13px',
              color: '#403e3e',
              textAlign: 'center',
              width: '100%'
            }}>
              <span>{t.loadingMobile.dontWantToContinue}</span>
              <Button
                onClick={handleCancel}
                sx={{
                  textTransform: 'none',
                  p: 0,
                  minWidth: 0,
                  color: '#387fc2',
                  fontFamily: 'inherit',
                  fontWeight: 'inherit',
                  fontSize: 'inherit',
                  '&:hover': {textDecoration: 'underline', bgcolor: 'transparent'}
                }}
              >
                {t.loadingMobile.returnToWebsite}
              </Button>
              <span>.</span>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NoCamera;
